import Model, { attr, belongsTo } from '@warp-drive/legacy/model';

import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  language: validator('presence', true),
  formId: validator('presence', true),
});

export default class NewsletterFormModel extends Model.extend(Validations) {
  @attr('string') language;
  @attr('string') formId;
  @attr('string') consentText;

  // Relations
  @belongsTo('newsletter-config', { async: true, inverse: 'newsletterForms' })
  newsletterConfig;
}
